import React from 'react';
import Icon from '../../../components/AppIcon';

const QuickStatsCard = ({ student }) => {
  const stats = [
    {
      label: 'Active IEP Goals',
      value: student?.stats?.activeGoals || 0,
      icon: 'Target',
      color: 'text-primary',
      bgColor: 'bg-primary/10'
    },
    {
      label: 'Completed Goals',
      value: student?.stats?.completedGoals || 0,
      icon: 'CheckCircle',
      color: 'text-success',
      bgColor: 'bg-success/10'
    },
    {
      label: 'Behavioral Incidents',
      value: student?.stats?.behavioralIncidents || 0,
      icon: 'AlertTriangle',
      color: 'text-warning',
      bgColor: 'bg-warning/10'
    },
    {
      label: 'Service Hours/Week',
      value: student?.stats?.serviceHours || 0,
      icon: 'Clock',
      color: 'text-secondary',
      bgColor: 'bg-secondary/10'
    }
  ];

  const progressPercentage = student?.stats?.overallProgress || 0;

  return (
    <div className="bg-card border border-border rounded-lg p-6">
      <h3 className="font-semibold text-card-foreground mb-4">Quick Stats</h3>
      <div className="space-y-4">
        {/* Overall Progress */}
        <div className="p-4 bg-muted rounded-lg">
          <div className="flex items-center justify-between mb-2">
            <span className="text-sm font-medium text-foreground">Overall Progress</span>
            <span className="text-sm font-semibold text-primary">{progressPercentage}%</span>
          </div>
          <div className="w-full bg-border rounded-full h-2">
            <div 
              className="bg-primary h-2 rounded-full transition-all duration-300"
              style={{ width: `${progressPercentage}%` }}
            />
          </div>
        </div>

        {/* Stats Grid */}
        <div className="grid grid-cols-2 gap-3">
          {stats?.map((stat, index) => (
            <div key={index} className="p-3 bg-muted rounded-lg">
              <div className="flex items-center gap-2 mb-1">
                <div className={`p-1.5 rounded ${stat?.bgColor}`}>
                  <Icon name={stat?.icon} size={14} className={stat?.color} />
                </div>
              </div>
              <div className="text-lg font-semibold text-foreground">{stat?.value}</div>
              <div className="text-xs text-muted-foreground">{stat?.label}</div>
            </div>
          ))}
        </div>

        {/* Last Updated */}
        <div className="pt-3 border-t border-border">
          <div className="flex items-center gap-2 text-xs text-muted-foreground">
            <Icon name="Clock" size={12} />
            <span>Last updated: {new Date(student.lastUpdated)?.toLocaleDateString()}</span>
          </div>
        </div>
      </div>
    </div>
  );
};

export default QuickStatsCard;